var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.items.length
    ? _c(
        "v-carousel",
        {
          attrs: {
            "delimiter-icon": "stop",
            "hide-delimiters": "",
            cycle: "",
            height: "180px",
            "show-arrows-on-hover": "",
            "hide-delimiter-background": "",
            "next-icon": "fad fa-chevron-right",
            "prev-icon": "fad fa-chevron-left",
            role: "region",
            "aria-label": "Latest community news carousel",
          },
        },
        _vm._l(_vm.items, function (item) {
          return _c(
            "v-carousel-item",
            {
              key: item.slug,
              staticClass: "landing-carsoul-item",
              attrs: {
                value: item.message,
                src: item.full_picture,
                ripple: true,
                role: "button",
                tabindex: "0",
                "aria-label": item.title + ": " + item.date,
              },
              on: {
                click: function ($event) {
                  return _vm.showDialog(item.slug)
                },
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.showDialog(item.slug)
                },
              },
            },
            [
              _c(
                "v-layout",
                {
                  staticClass: "landing-carsoul-content",
                  attrs: {
                    column: "",
                    "align-center": "",
                    "justify-center": "",
                  },
                },
                [
                  _c("div", {
                    staticClass: "landing-carsoul-content-title",
                    attrs: { role: "heading", "aria-level": "2" },
                    domProps: { innerHTML: _vm._s(item.title) },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "landing-carsoul-content-date",
                      attrs: { role: "text" },
                    },
                    [_vm._v("\n        " + _vm._s(item.date) + "\n      ")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(item.title) +
                        " - " +
                        _vm._s(item.date) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-divider", {
                    attrs: { role: "presentation", "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("v-layout", {
                    staticClass: "landing-carsoul-content-btns",
                    attrs: { "align-center": "", role: "presentation" },
                  }),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }